module.exports = __webpack_public_path__ + "img/remove.fb4cd54c.svg";